import http from 'plugins/axios';

export default {
  //获取配置信息
  reqList({ page = 1, size = 50, confKey = '' }) {
    return http.get({
      url: `/la/admin/site/conf/list?page=${page}&size=${size}&confKey=${confKey}`,
      //  data:{confKey}
    });
  },
  //查询
  getCurrencyTransferList(data) {
    return http.get({
      url: '/la/admin/transferSupportCoin/task/list',
      data
    })
  },
  //添加或修改
  updateOrAdd(data) {
    return http.post({
      url: '/la/admin/transferSupportCoin/add',
      data
    })
  },

  updateOrUpdateStatus(data) {
    return http.post({
      url: '/la/admin/transferSupportCoin/updateStatus',
      data,
      dataType: 'form'
    })
  },
  //删除
  delOne(id) {
    return http.post({
      url: `/la/admin/transferSupportCoin/deleteTransfer?id=${id}`,
      // data:{id}
    })
  },

  getCurrencyDetail(id) {
    return http.get({
      url: '/la/admin/transferSupportCoin/getInfo',
      data: {
        id
      }
    });
  },

};
